import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";

import Layout from "./layout";

export default function MainRoutes() {
  return (
    <Routes>
      <Route index element={<Navigate to="layout" replace />} />
      <Route path="layout/*" element={<Layout />} />
      <Route path="*" element={<Navigate to="/error" replace />} />
    </Routes>
  );
}
